// Angular
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ROLES } from "app/_constants/roles";
import { AlphaGuard } from "app/_guards/alpha.guard";
import { DraftDossierListComponent } from "./draft-dossier-list/draft-dossier-list/draft-dossier-list.component";



const routes: Routes = [
  {
    path: "",
    data: {
      title: "DraftDossier",
      breadcrumbs: "",
    },
    children: [
      {
        path: "draftDossierList",
        component: DraftDossierListComponent,
       canActivate: [AlphaGuard],
        data: {
          requiredRoles: [ROLES.ADMINISTRATORS, ROLES.ADVANCED_MEDICAL_ASSISTANT, ROLES.INTERMEDIATE_MEDICAL_ASSISTANT, ROLES.BEGINNER_MEDICAL_ASSISTANT]
          }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [AlphaGuard],
})
export class DraftDossierRoutingModule { }
